var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('OpenDialog',{attrs:{"overlay":true},on:{"close":_vm.closeDialog}},[(_vm.currentSmartGuide)?_c('SmartGuidePlayer',{attrs:{"smartGuide":_vm.currentSmartGuide}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }